module.exports = __webpack_public_path__ + "img/banner.2d11a91e.png";